// pro solid icons (fas)
const icons = [
    'faArrowAltRight',
    'faAsterisk',
    'faBookmark',
    'faCaretDown',
    'faCaretUp',
    'faCheck',
    'faCircle',
    'faCircleDot',
    'faColumns',
    'faDollarSign',
    'faSortDown',
    'faFilter',
    'faFlag',
    'faGlobeAmericas',
    'faMapMarkerAlt',
    'faPeoplePantsSimple',
    'faPeopleRoof',
    'faStar',
    'faStarHalfAlt',
    'faSort',
    'faSortUp',
    'faUnlock',
    'faUsers',
    'faPrescriptionBottle',
    'faPersonCirclePlus',
    'faFlask',
    'faHeading',
    'faArrowUp',
    'faChartPie',
    'faTriangleExclamation',
    // Lens Help answer rating (#6535)
    'faThumbsUp',
    'faThumbsDown',
];

// Import all icons
import * as iconsModule from '@fortawesome/pro-solid-svg-icons';

export default (library) => {
    // Add all icons to the library
    icons.forEach((iconName) => {
        if (iconsModule[iconName]) {
            library.add(iconsModule[iconName]);
        }
    });
};
